(() => {
  if (customElements.get('corner-assurance')) return;
  customElements.define('corner-assurance', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-corner-open]');
      this.dialog = this.querySelector('dialog');
      if (!this.link || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.media = window.matchMedia('(max-width: 767px)');
      this.link.setAttribute('aria-haspopup', 'dialog');
      this.link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.media.matches) return;
        event.preventDefault();
        this.dialog.showModal();
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
      }, options);
      this.querySelector('[data-corner-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientY < bounds.top || event.clientY > bounds.bottom || event.clientX < bounds.left || event.clientX > bounds.right) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.unlock(), options);
      this.media.addEventListener('change', () => { if (!this.media.matches && this.dialog.open) this.dialog.close(); }, options);
    }
    unlock() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.oldOverflow;
      this.locked = false;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      this.controller?.abort();
    }
  });
})();
